"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));
var _buttonview = _interopRequireDefault(require("@ckeditor/ckeditor5-ui/src/button/buttonview"));
// 基础功能组件

// 按钮视图组件

// 按钮的图标 SVG
var uploadVideoIcon = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n  viewBox=\"0 0 200 200\" style=\"enable-background:new 0 0 200 200;\" xml:space=\"preserve\">\n<path d=\"M99.9,82.2L99.9,82.2L99.9,82.2h0.2H99.9z M96.8,83.6l-36.9,36.8c-1.8,1.8-1.8,4.7,0,6.6c1.8,1.8,4.7,1.8,6.6,0l29-29v62.3\n c0,2.5,2.1,4.7,4.6,4.7c2.6,0,4.6-2.2,4.6-4.7V98l29,29c1.8,1.8,4.7,1.8,6.6,0c1.7-1.9,1.7-4.8,0-6.6l-37-36.8l-0.2-0.2l-0.2-0.2\n c-0.3-0.3-0.5-0.4-0.6-0.5H102c-0.3-0.3-0.5-0.3-0.8-0.3l-0.5-0.1l-0.4-0.1h-0.4h-0.5l-0.4,0.1l-0.4,0.1c-0.3,0-0.5,0.1-0.7,0.2\n l-0.3,0.1c-0.2,0.2-0.4,0.3-0.5,0.4L97,83.3L96.8,83.6z M160.2,149.7c6.7-0.1,12.9-2.8,17.2-7.2c4.4-4.5,7.2-10.6,7.2-17.4\n c0-6-2.1-11.5-5.6-15.9c-3.6-4.3-8.8-7.3-14.7-8.3c-3.8-0.8-6.5-3.9-6.5-7.6v-0.1c0-14.6-5.9-27.9-15.5-37.4\n c-9.6-9.6-22.8-15.5-37.3-15.5c-10.8,0-20.9,3.2-29.2,8.6c-8.6,5.8-15.4,13.8-19.6,23.4c-1.2,2.9-3.9,4.6-6.9,4.7\n c-9.5,0.5-17.9,4.7-24.1,11.3c-6.1,6.4-9.8,15.2-9.8,24.9c0,10.1,4,19.2,10.6,25.8h0.1c6.6,6.6,15.6,10.6,25.6,10.6h3.2h0.2h19.7\n h2.3c4.3,0,7.8,3.5,7.8,7.7s-3.5,7.7-7.8,7.7h-2.3H55.1h-0.2h-3.2c-14.3,0-27.2-5.7-36.6-15.3C5.8,140.5,0,127.6,0,113.3\n C0,99.6,5.3,87,14.1,77.8c7.8-8.1,18.2-13.8,29.9-15.6c5.4-10.6,13.5-19.4,23.3-25.9C78.2,29.1,91.1,25,105,25\n c18.8,0,35.8,7.6,48.2,20c11,11.1,18.3,25.9,19.8,42.3c6.9,2.3,13,6.7,17.5,12.1c5.9,7,9.4,16,9.4,25.7c0,11.1-4.5,21.1-11.7,28.3\n h-0.1c-6.3,6.4-14.8,10.5-24.2,11.5c-0.6,0.1-1.2,0.2-1.8,0.2h-2H160h-34.2h-0.3c-4.2,0-7.7-3.5-7.7-7.7s3.4-7.7,7.7-7.7h0.3H160.2z\n \"/>\n</svg>\n";
// 自定义组件需要继承基础组件
var UploadVideo = /*#__PURE__*/function (_Plugin) {
  function UploadVideo() {
    (0, _classCallCheck2.default)(this, UploadVideo);
    return (0, _callSuper2.default)(this, UploadVideo, arguments);
  }
  (0, _inherits2.default)(UploadVideo, _Plugin);
  return (0, _createClass2.default)(UploadVideo, [{
    key: "init",
    value:
    // 重写基础组件的初始化函数
    function init() {
      // 获取当前编辑器
      var editor = this.editor;
      // 从当前编辑器的配置中获取传入的自定义配置名称
      var uploadVideo = this.editor.config.get('uploadVideo');

      // 将自定义按钮添加到当前编辑器的组件工厂
      editor.ui.componentFactory.add('uploadVideo', function (locale) {
        // 获取当前编辑器的按钮视图
        var view = new _buttonview.default(locale);

        // 在按钮视图中注入自定义按钮的名称、图标
        view.set({
          label: '上传视频',
          icon: uploadVideoIcon,
          // 开启提示，当鼠标悬浮到按钮上，会显示 label 指定的 uploadVideo 字样
          tooltip: true
        });

        // 点击按钮
        view.on('execute', function () {
          // 执行自定义配置中指定的回调函数
          uploadVideo.handler.call();
        });

        // 返回修改后的视图内容
        return view;
      });
    }
  }]);
}(_plugin.default); // 对外暴漏自定义组件
var _default = exports.default = UploadVideo;